/* Glideon — Nano Glass product-page motion + FAQ accordion.
   Plain script (no module imports). Loaded once; guards against re-init.
   The page renders fully without this file: bars show their value, the FAQ
   is a native <details> list. */
(function () {
  if (window.__nanoGlideon) return;
  window.__nanoGlideon = true;

  var reduce =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- comparison bars: fill on first scroll into view -------------- */
  function initBars() {
    if (reduce || !('IntersectionObserver' in window)) return; // stay drawn-to-value

    var bars = document.querySelectorAll('.gd-bar');
    if (!bars.length) return;

    bars.forEach(function (b) {
      b.classList.add('gd-bar--pending');
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.35 }
    );

    bars.forEach(function (b) {
      io.observe(b);
    });

    // Safety net: if the observer never fires (odd scroll containers, etc.),
    // fill everything after a few seconds so no bar is left empty.
    setTimeout(function () {
      bars.forEach(function (b) {
        b.classList.add('is-in');
      });
    }, 4000);
  }

  /* ---- quick facts: staggered fade/slide-in on scroll -------------- */
  function initQuickFacts() {
    if (reduce || !('IntersectionObserver' in window)) return; // stay fully visible

    var lists = document.querySelectorAll('[data-gd-qf]');
    if (!lists.length) return;

    lists.forEach(function (list) {
      list.classList.add('gd-qf__list--js');
      var cards = list.querySelectorAll('.gd-qf__card');
      if (!cards.length) return;

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          });
        },
        { threshold: 0.3 }
      );

      cards.forEach(function (c) {
        io.observe(c);
      });

      // Safety net: never leave a card stuck at opacity 0.
      setTimeout(function () {
        cards.forEach(function (c) {
          c.classList.add('is-in');
        });
      }, 4000);
    });
  }

  /* ---- closer look: staggered fade/slide-in + media scale-in ------- */
  function initCloser() {
    if (reduce || !('IntersectionObserver' in window)) return; // stay fully visible

    var lists = document.querySelectorAll('[data-gd-closer]');
    lists.forEach(function (list) {
      list.classList.add('gd-closer__specs--js');
      var specs = list.querySelectorAll('.gd-closer__spec');
      if (!specs.length) return;

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          });
        },
        { threshold: 0.3 }
      );

      specs.forEach(function (s) {
        io.observe(s);
      });

      // Safety net: never leave a spec stuck at opacity 0.
      setTimeout(function () {
        specs.forEach(function (s) {
          s.classList.add('is-in');
        });
      }, 4000);
    });

    var media = document.querySelectorAll('[data-gd-closer-media]');
    if (!media.length) return;

    media.forEach(function (m) {
      m.classList.add('gd-closer__media--js');
    });

    var mediaIo = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          mediaIo.unobserve(entry.target);
        });
      },
      { threshold: 0.3 }
    );

    media.forEach(function (m) {
      mediaIo.observe(m);
    });

    setTimeout(function () {
      media.forEach(function (m) {
        m.classList.add('is-in');
      });
    }, 4000);
  }

  /* ---- steps: photo, then steps staggered, then CTA last ----------- */
  function initStepsReveal() {
    if (reduce || !('IntersectionObserver' in window)) return; // stay fully visible

    var bodies = document.querySelectorAll('[data-gd-steps]');
    bodies.forEach(function (body) {
      body.classList.add('gd-steps__body--js');
      var items = body.querySelectorAll('[data-gd-steps-item]');
      if (!items.length) return;

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          });
        },
        { threshold: 0.3 }
      );

      items.forEach(function (i) {
        io.observe(i);
      });

      // Safety net: never leave an item stuck at opacity 0.
      setTimeout(function () {
        items.forEach(function (i) {
          i.classList.add('is-in');
        });
      }, 4000);
    });
  }

  /* ---- lazy video: play only once scrolled into view --------------- */
  function initLazyVideo() {
    var wrappers = document.querySelectorAll('[data-gd-lazy-video]');
    if (!wrappers.length) return;

    wrappers.forEach(function (wrap) {
      var video = wrap.querySelector('video');
      if (!video) return;

      // Reduced motion: leave the video on its first frame, paused. It's
      // still the section's real content (not decoration), just not
      // auto-moving — a native play button isn't shown (controls stay
      // off per spec), so this reads as a static still.
      if (reduce) return;

      // No IntersectionObserver: fall back to the video's own native
      // behaviour (muted + loop still work; browsers may or may not
      // autoplay without a user gesture, but nothing breaks either way).
      if (!('IntersectionObserver' in window)) {
        video.setAttribute('autoplay', '');
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var playPromise = video.play();
              if (playPromise && playPromise.catch) playPromise.catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.35 }
      );

      io.observe(video);
    });
  }

  /* ---- FAQ accordion: single-open (smooth height is CSS) ----------- */
  function initFaq() {
    var groups = document.querySelectorAll('[data-gd-faq]');
    groups.forEach(function (group) {
      group.classList.add('gd-faq--js');
      var items = group.querySelectorAll('.gd-faq__item');

      items.forEach(function (item) {
        var summary = item.querySelector('summary');
        if (!summary) return;

        summary.addEventListener('click', function () {
          if (group.dataset.gdFaq === 'single' && !item.open) {
            window.requestAnimationFrame(function () {
              items.forEach(function (other) {
                if (other !== item) other.open = false;
              });
            });
          }
        });
      });
    });
  }

  function init() {
    initBars();
    initQuickFacts();
    initCloser();
    initStepsReveal();
    initLazyVideo();
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when a section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', init);
})();
